import React from 'react';
import styled from 'styled-components/macro';

import { AllowPartner } from '../auth/accessToken/Allow';
import BackToPartner from '../auth/accessToken/BackToPartner';

const LeaveInspectAppBarButton = () => (
    <Wrapper>
        <AllowPartner>
            <BackToPartner />
        </AllowPartner>
    </Wrapper>
);

const Wrapper = styled.div`
    margin: 0 auto;
    padding: 8px;
`;

export default LeaveInspectAppBarButton;
